import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms'
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';


@Component({
  selector: 'app-case-study-delay',
  templateUrl: './case-study-delay.component.html',
  styleUrls: ['./case-study-delay.component.scss']
})
export class CaseStudyDelayComponent implements OnInit {
  @Input('learner') learnerData;
  @Input('singleJob') jobData;
  @Input('assesment') assessmentPlanEdit;
  caseStudyDelayForm
  learnerName
  isEdit: boolean = false
  caseStudyDelayEdit
  patientSign: boolean
  learnerSign: boolean
  loading
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
  ) { }


  ngOnInit() {
    if(!this.isEdit)
      this.caseStudyDelayCreateForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of job and learner data", changes);
    if (changes.jobData && changes.jobData.currentValue) {
      this.jobData = changes.jobData.currentValue[0]
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);

    }

    if (changes.learnerData && changes.learnerData.currentValue && changes.learnerData.currentValue != undefined) {
      this.learnerData = changes.learnerData.currentValue
      this.learnerName = this.learnerData.name
    }

    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      this.caseStudyDelayEdit = changes.assessmentPlanEdit.currentValue
      console.log("edit form value", this.caseStudyDelayEdit);
 

        if (this.caseStudyDelayEdit && this.caseStudyDelayEdit.caseStudyDelayForm) {
          if (this.caseStudyDelayEdit.caseStudyDelayForm && this.caseStudyDelayEdit.caseStudyDelayForm.patientSign != "") {
            this.patientSign = true
          }
          if (this.caseStudyDelayEdit.caseStudyDelayForm && this.caseStudyDelayEdit.caseStudyDelayForm.learnerSign != "") {
            this.learnerSign = true
          }

        }
        // this.selectedTrainer = this.specimanEdit.specimanForm.trainer
        this.isEdit = true
        this.caseStudyDelayCreateForm(this.caseStudyDelayEdit)
   
    }else{
      this.caseStudyDelayCreateForm()
    }

  }


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  addSignature(fomrControl) {


    this.openDialog(SignaturePadComponent).subscribe((data) => {
      console.log("data of sign", data);
      if (data == undefined) return

      let sign = data


      // if (formType == 'trackMaintenance') {
      if (fomrControl == 'patientSign') {
        this.patientSign = true
        this.caseStudyDelayForm.patchValue({
          patientSign: sign
        })
      }
      if (fomrControl == 'learnerSign') {
        this.learnerSign = true
        this.caseStudyDelayForm.patchValue({
          learnerSign: sign
        })
      }

      // if (formType == 'trackMaintenance') {

      // }
    })

  }


  caseStudyDelayCreateForm(details?) {
    this.caseStudyDelayForm = new FormGroup({
      name: new FormControl((details && details.caseStudyDelayForm) ? details.caseStudyDelayForm.name : ''),
      date: new FormControl((details && details.caseStudyDelayForm) ? details.caseStudyDelayForm.date : ''),
      witness: new FormControl((details && details.caseStudyDelayForm) ? details.caseStudyDelayForm.witness : ''),
      patientSign: new FormControl((details && details.caseStudyDelayForm) ? details.caseStudyDelayForm.patientSign : ''),
      learnerSign: new FormControl((details && details.caseStudyDelayForm) ? details.caseStudyDelayForm.learnerSign : ''),
    })
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'caseStudyDelayForm')
      this.caseStudyDelayForm.get(formControl).setValue(value);

  }

  submitform() {
    console.log("submit form value =======>", this.caseStudyDelayForm.value)
    // this.loading = true

    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        caseStudyDelayForm: this.caseStudyDelayForm.value,
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })


  }

}
